;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .controller('AddLineController', AddLineController)

  AddLineController.$inject = [
    // Angular
    '$uibModalInstance', '$rootScope', 'urls',

    // Managers
    'ProductManager', 'ProductTypeManager',

    // Services
    'PreferencesService', 'FilterService', 'SessionService',

    // Resolve
    'invoice', 'line', 'vatList', 'categories', 'action', 'manager', 'pagination', 'type', 'rubrics', 'manageSubcontract', 'grant'

  ]

  function AddLineController (
    // Angular
    $uibModalInstance, $rootScope, urls,
    // Managers
    ProductManager, ProductTypeManager,
    // Service
    PreferencesService, FilterService, SessionService,
    // Resolve
    invoice, line, vatList, categories, action, manager, pagination, type, rubrics, manageSubcontract, grant
  ) {
    var self = this

    _.extend(self, {
      // Attributes
      action: action,
      categories: categories,
      vatList: vatList,
      pagination: pagination,
      manageSubcontract: manageSubcontract,
      products: [],
      searchCategories: [],
      outBpu: false,
      step: 1,
      type: type,
      rubrics: rubrics,
      grant: grant,
      company: SessionService.getCompany(),
      image: undefined,
      // Methods
      cancel: cancel,
      getVatList: getVatList,
      searchProducts: searchProducts,
      selectProduct: selectProduct,
      getCategories: getCategories,
      switchToDefaultConditions: switchToDefaultConditions,
      switchToSpecificConditions: switchToSpecificConditions,
      addLine: addLine,
      groupFind: FilterService.groupFind,
      removeDiscount: removeDiscount,
      isDiscountInvalid: isDiscountInvalid,
      resetDiscount: resetDiscount,
      clearSearch: clearSearch,
      getList: getList,
      searchProductRef: searchProductRef,
      searchProductLabel: searchProductLabel,
      searchProductCategory: searchProductCategory,
      searchTags: searchTags,
      addCriteria: addCriteria,
      sort: sort,
      createNewCategory: createNewCategory,
      checkPrice: checkPrice,
      getUrl: getUrl
    })

    function init () {
      ProductTypeManager.getAllByBatch(ProductTypeManager.query()).then(function (data) {
        self.productTypes = data.data.filter((el) => self.grant ? el.grant : !el.grant)
        self.producTypesGrant = data.data.filter((el) => el.grant)
        self.conditons = self.grant ? { type: { $in: self.producTypesGrant.map((el) => { return el._id }), $exists: true } } : {
          type: {
            $nin: self.producTypesGrant.map((el) => {
              return el._id
            })
          }
        }
        if (line) {
          self.line = line
          if (self.line.product && self.action !== 'editValid' && self.action !== 'editLine') {
            ProductManager.get(
              ProductManager
                .query({ conditions: { 'flags': 'sufa', type: { $nin: self.producTypesGrant.map((el) => { return el._id }) } } })
                .select(self.line.product, '_id')
            ).then(function (result) {
              selectProduct(result.data[0])
            })
            ProductManager.getById(self.line.product).then(function (data) {
              self.image = data.image
            })
          }
          if (self.line.productType && typeof self.line.productType === 'string') {
            ProductTypeManager.getById(self.line.productType).then(function (data) {
              self.line.productType = data
            })
          }
          self.step = 2
        }
        self.invoice = invoice
        if (self.line && self.line.category) {
          self.category = self.line.category
        }
        self.addCategory = false
        self.saveNewProduct = false
        self.saveModification = false
        PreferencesService.getGeneralPrefs().then(function (preferences) {
          self.defaultVAT = _.get(preferences, 'defaults.vat')
          self.defaultUnit = _.get(preferences, 'defaults.unit')
        })
        PreferencesService.getCompanyPrefs().then((companyPrefs) => {
          self.allowSubcontracts = _.get(companyPrefs, 'enabledFeatures.subcontracts')
          self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.requiredForExport')
        })
        getList()
      })
    }

    init()

    function resetDiscount () {
      delete self.line.discount.amount
    }

    function removeDiscount () {
      delete self.line.discount
    }
    function getUrl () {
      if (!self.image) {
        return '/assets/images/default.png'
      }
      return urls.downloader + '/image/' + self.company + '/' + self.image
    }

    function getCategories (search) {
      var value = _.map(_.filter(_.get(self, 'categories', []), function (c) {
        if (!search) {
          return true
        }
        return c.v.match(new RegExp('.*' + search + '.*', 'i'))
      }), 'v')
      if (!_.includes(value, '   ')) {
        value.unshift('   ')
      }
      return value
    }

    function getVatList (search) {
      var newVats = self.vatList.slice()
      if (search && newVats.indexOf(search) === -1) {
        newVats.unshift(search)
      }
      return newVats
    }

    function searchProducts (query) {
      return ProductManager.get(
        ProductManager
          .query({
            conditions: JSON.stringify({
              'flags': 'sufa',
              ...self.conditons,
              $or: [
                {
                  label: {
                    $regex: query,
                    $options: 'i'
                  }
                },
                {
                  reference: {
                    $regex: query,
                    $options: 'i'
                  }
                }]
            }),
            populate: JSON.stringify([
              { path: 'type' }
            ])
          }
          )
          .limit(10))
        .then(function (result) {
          return result.data
        })
    }

    function selectProduct (product) {
      self.selectedProduct = product
      self.saveNewProduct = !product._id

      if (_.get(invoice, 'client._id')) {
        self.specificConditions = _.find(product.clientConditions, {client: invoice.client._id})
      }

      if (_.get(invoice, 'bpu._id')) {
        switchToDefaultConditions()
      } else {
        switchToSpecificConditions()
      }

      if (product._id) {
        self.line.product = product._id
        self.line.productType = product.type
        self.category = product.category
        self.image = product.image
        if (action === 'new' && product.hasOwnProperty('defaultQuantity')) {
          self.line.quantity = product.defaultQuantity
        }
      }
      self.line.grant = self.grant
      self.found = true
      next()
    }

    function switchToDefaultConditions () {
      self.isSpecific = false
      var qt
      if (self.line && self.line.quantity) {
        qt = self.line.quantity
      }
      self.line = {
        invoice: invoice._id,
        product: angular.copy(self.selectedProduct._id),
        label: angular.copy(self.selectedProduct.label),
        description: self.selectedProduct.description,
        reference: angular.copy(self.selectedProduct.reference),
        price: angular.copy(self.selectedProduct.price),
        unit: angular.copy(self.selectedProduct.unit) || self.defaultUnit,
        VAT: angular.copy(self.selectedProduct.VAT) || self.defaultVAT,
        grant: self.grant
      }
      if (qt) {
        self.line.quantity = qt
      }
    }

    function switchToSpecificConditions () {
      self.isSpecific = true
      var qt
      if (self.line && self.line.quantity) {
        qt = self.line.quantity
      }
      self.line = {
        invoice: invoice._id,
        product: angular.copy(self.selectedProduct._id),
        label: angular.copy(_.get(self, 'specificConditions.label', _.get(self, 'selectedProduct.label'))),
        reference: angular.copy(_.get(self, 'specificConditions.reference', _.get(self, 'selectedProduct.reference'))),
        description: angular.copy(_.get(self, 'specificConditions.description', _.get(self, 'selectedProduct.description'))),
        price: angular.copy(_.get(self, 'specificConditions.price', _.get(self, 'selectedProduct.price'))),
        unit: angular.copy(_.get(self, 'specificConditions.unit', _.get(self, 'selectedProduct.unit', self.defaultUnit))),
        VAT: angular.copy(_.get(self, 'specificConditions.VAT', _.get(self, 'selectedProduct.VAT', self.defaultVAT))),
        grant: self.grant
      }
      if (qt) {
        self.line.quantity = qt
      }
    }

    function saveLine (editSubcontract) {
      if (self.addCategory) {
        var category = manager.create({label: self.category, type: 'label'})
      }
      if (self.line.rubric && self.line.rubric.rubric) {
      	self.line.rubric = self.line.rubric.rubric._id
			}
      self.line.rubric = _.get(self, 'line.rubric', undefined)
      self.line.category = self.category
      var line = manager.create(self.line)
      line.price.amount = isNaN(line.price.amount) ? 0 : line.price.amount
      line.productType = self.line.productType
      line.grant = self.grant
      $uibModalInstance.close({ line: line, category: category, editSubcontract, saveModification: self.saveModification })
    }

    function addLine (editSubcontract) {
      if (self.selectedProduct && !self.selectedProduct._id && self.saveNewProduct) {
        var p = ProductManager.create({
          label: self.line.label,
          reference: self.line.reference,
          description: self.line.description,
          type: self.line.productType,
          price: self.line.price,
          unit: self.line.unit,
          VAT: self.line.VAT,
          grant : self.grant
        })
        p.price.amount = isNaN(p.price.amount) ? 0 : p.price.amount
        p.save().then(function () {
          self.line.product = p._id
          saveLine(editSubcontract)
        })
      } else {
        saveLine(editSubcontract)
      }
    }

    function isDiscountInvalid () {
      if (!self.line) return true
      if (!self.line.discount || !self.line.discount.type) return false
      return isNaN(self.line.discount.amount) || self.line.discount.amount === 0
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function next () {
      switch (self.step) {
        case 1:
          self.step = 2
      }
      if (self.step === 2 && self.grant) {
        self.line.VAT = 0
        self.line.productType = self.productTypes[0]
      }
    }

    function checkPrice () {
      if (self.grant) {
        self.line.price.amount = self.line.price.amount <= 0 ? self.line.price.amount : -self.line.price.amount
      }
    }

    // SEARCH

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.loading = true

      self.pagination.orderBy = self.pagination.orderBy || '-createdAt'

      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search)
      if (!hasArchived) {
        addCriteria('isArchived', {_id: 'archived', value: 'false'})
        return
      }

      var queryString
      if (!self.outBpu) {
        queryString = {
          conditions: {
            bpu: _.get(self, 'invoice.bpu._id'),
            ...self.conditons
          },
          populate: JSON.stringify([
            {
              path: 'tags'
            },
            {
              path: 'type'
            }
          ])
        }
      } else {
        queryString = {
          conditions: {
            ...self.conditons
          }
        }
      }

      var query =
        ProductManager
          .query(queryString)
          .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }
      var promise = ProductManager.post(query)
      promise.then(function (data) {
        self.products = data.data
        self.pagination.totalElements = data.meta.total
        self.loading = false
        if (parseInt(data.meta.total) !== 0 && !data.data.length) {
          self.pagination.currentPage = 0
          getList()
        }
      })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function clearSearch () {
      self.pagination.search = {}
      getList()
    }

    function searchProductRef (search) {
      return FilterService.searchProductRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function searchProductLabel (search) {
      return FilterService.searchProductLabel(search).then(function (labels) {
        self.labels = labels
      })
    }

    function searchProductCategory (search) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(
        ProductManager.query({ sort: 'category', distinct: 'category', conditions: { 'flags': 'sufa', ...self.conditons } })
          .paginate({ limit: 20 })
          .search(search, 'category'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          self.searchCategories = _.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin')
          self.categories = self.searchCategories.map(({v}) => v)
          return self.categories
        })
    }

    function searchTags (query) {
      return FilterService.searchTags(query).then(function (tags) {
        self.tags = tags
      })
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function createNewCategory (category) {
      self.category = category
      $rootScope.$broadcast('close-ui-select:add-line')
    }
  }
})
(window.angular, window._)
